module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_500_1000.0801d237.png";